import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    '& .MuiTypography-button': {
      textDecoration: 'none',
      fontWeight: 500,
    },
    padding: 0,
    height: '16px',
  },
});

export default useStyles;
